/* eslint-disable react-hooks/exhaustive-deps */
import { connect } from "react-redux";
import { Select, Modal, Table, Button, message } from 'antd';
import { CustomIcon, ModalHeader } from "datastake-daf/dist/components";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { MODAL_WIDTH } from "../config";
import { actions } from "../../../../store/reducers/authentication";
import { useApplications } from "../../../../context/Applications";
import { AdminService } from "../../../../services";

function ReviewModal({
  authentication: { user },
  getRegistrationOptions,
  selectedUser = {},
  handleCancel = () => { },
  t = (s) => s,
  onUsersSubmit = () => { },
}) {
  const [loading, setLoading] = useState(false);
  const { applications } = useApplications();
  const [data, setData] = useState(
    (selectedUser?.apps || []).map((app, i) => {
      const c = applications.find((c) => c.app === app.app) || {};
      return {
        ...c,
        key: i,
        access: app.access,
        interface: app.interface,
      };
    })
  );

  const changeAppData = useCallback((appKey, val) => {
    setData((p) => p.map((app) => {
      if (app.app === appKey) {
        return { ...app, ...val };
      }

      return app;
    }));
  }, []);

  const dataSource = useMemo(() => {
    const emptyDataSource = [];

    for (let i = 0; i < 10; i++) {
      emptyDataSource.push({ id: i, empty: true, key: i });
    }

    return emptyDataSource.map((empty, i) => data[i] || empty);
  }, [data]);

  useEffect(() => {
    getRegistrationOptions({ language: user.language });
  }, [user.language])

  useEffect(() => {
    if (!data.length) {
      onUsersSubmit();
    }
  }, [data]);

  const onApprove = useCallback(async (req) => {
    setLoading(true);

    try {
      await AdminService.approveAccount(selectedUser.id, { app: req.app, interface: req.interface });
      setData((prev) => [...prev.filter((d) => d.app !== req.app)])
      message.success(t('Application access successfully approved'))
    } catch (err) {
      message.error(err?.message || t('Error occurred'));
    }

    setLoading(false);
  }, []);

  const onDecline = useCallback(async (req) => {
    setLoading(true);

    try {
      await AdminService.declineAccount(selectedUser.id, { app: req.app, interface: req.interface });
      setData((prev) => [...prev.filter((d) => d.app !== req.app)])
      message.success(t('Application access successfully declined'))
    } catch (err) {
      message.error(err?.message || t('Error occurred'));
    }

    setLoading(false);
  }, []);

  const columns = useMemo(() => [
    {
      title: t('Application'),
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
    },
    {
      title: t('Interface'),
      dataIndex: 'interface',
      key: 'interface',
      ellipsis: true,
      render: (val, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        return (
          <div className="daf-default-cell">
            <Select
              value={val}
              size="small"
              style={{ width: 150 }}
              onChange={(val) => {
                changeAppData(all.app, { interface: val });
              }}
            >
              {(all.interfaces || []).map((i) => (
                <Select.Option key={i.value} value={i.value}>
                  {i.label}
                </Select.Option>
              ))}
            </Select>
          </div>
        );
      }
    },
    {
      title: t('Access'),
      dataIndex: 'access',
      key: 'access',
      ellipsis: true,
      render: (val, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        return (
          <div className="daf-default-cell flex">
            <Button
              size="small"
              type="primary"
              onClick={() => {
                Modal.confirm({
                  title: t('Are you sure you want to approve access to this application?'),
                  okText: t('Yes'),
                  cancelText: t('Cancel'),
                  onOk: () => {
                    onApprove(all);
                  },
                })
              }}
              className="mr-1 min-w-32"
              icon={<CustomIcon name="Check" width={11} height={11} />} />
            <Button
              size="small"
              className="min-w-32"
              onClick={() => {
                Modal.confirm({
                  title: t('Are you sure you want to decline access to this application?'),
                  okText: t('Yes'),
                  cancelText: t('Cancel'),
                  onOk: () => {
                    onDecline(all);
                  },
                })
              }}
              icon={<CustomIcon name="Close" width={8} height={8} />} />
          </div>
        )
      }
    },
  ], [t, changeAppData, onApprove, onDecline]);

  return (
    <Modal
      centered
      wrapClassName="bordered-footer no-p-body-mobile"
      title={(
        <ModalHeader title={t('Review Request')} />
      )}
      footer={null}
      // footer={[
      //   <Footer
      //     t={t}
      //     key="footer"
      //     className="mt-0"
      //     onSubmit={onSubmit}
      //     onClose={handleCancel}
      //     disabledFooter={!hasChanges}
      //   />
      // ]}
      open={selectedUser}
      onCancel={handleCancel}
      width={MODAL_WIDTH}
    >
      <div className="daf-table-wrapper flex-1 flex-c extra-small small-body no-pagination">
        <Table
          renderWrapper={false}
          size="small"
          loading={loading}
          rowKey="key"
          columns={columns}
          dataSource={dataSource}
          doEmptyRows
          scroll={{ x: 500 }}
        />
      </div>
    </Modal>
  )
}

const mstp = ({ authentication }) => ({ authentication });

export default connect(mstp, actions)(ReviewModal);
